import { createSelector } from 'reselect';
import { utility } from '../../../../services';
import columns from './components/MarketsTableComponent/columns';

function getTickerCellData(data) {
  let { ticker, logoUrl } = data;
  ticker = ticker.split('-')[1];
  return {
    ticker,
    logoUrl,
  };
}
function getBaseCellData(data) {
  const { ticker } = data;
  return ticker.split('-')[0];
}
function getThirtyMinBaseVolumeAvg(data) {
  const { thirtyMinBaseValue, thirtyMinBvRatio } = data;
  const twentyDayBV = thirtyMinBaseValue / thirtyMinBvRatio;
  const averageThirtyMin = twentyDayBV / (20 * 48);
  const value =
    100 * (thirtyMinBaseValue - averageThirtyMin) / averageThirtyMin;
  if (isNaN(value)) {
    return null;
  }
  return value;
}
function get24HourPriceChange(data) {
  const { prevDay, lastOrderPrice } = data;

  if (!prevDay || !lastOrderPrice) {
    return null;
  }
  const change = 100 * (lastOrderPrice - prevDay) / prevDay;
  return change;
}
function flatten(segments) {
  let data = {};
  Object.keys(segments).forEach(key => {
    const segment = segments[key];
    Object.keys(segment).forEach(k => {
      const secondKey = utility.capitalizeFirstLetter(k);
      const fullKey = `${key}${secondKey}`;
      data[fullKey] = segment[k];
    });
  });
  return data;
}

const marketsSelector = state => state.markets;
const snapshotsSelector = state => state.snapshots;

const mergeDataSelector = createSelector(
  marketsSelector,
  snapshotsSelector,
  (markets, snapshots) => {
    const keys = Object.keys(markets);
    let data = {};
    let objects = {};
    Object.keys(snapshots).forEach(key => {
      const snapshot = snapshots[key];
      let { ticker, exchange, segments, lastOrder, market } = snapshot;
      // console.log(ticker, ' MARKET: ', market);
      if (!market) {
        market = {};
      }
      const {
        rsi,
        ask,
        bid,
        high,
        last,
        prevDay,
        low,
        baseVolume,
        volume,
      } = market;
      const lastOrderPrice = lastOrder.p;
      const lastOrderQuantity = lastOrder.q;
      data[key] = Object.assign(
        {
          ticker,
          exchange,
          rsi,
          ask,
          bid,
          high,
          last,
          low,
          prevDay,
          baseVolume,
          volume,
          lastOrderPrice,
          lastOrderQuantity,
        },
        flatten(segments),
      );
    });
    keys.forEach(key => {
      const market = markets[key];
      const snapshot = data[key] || {};
      const merged = market.merge(snapshot);
      const custom = {
        key: `${merged.exchange}-${merged.ticker}`,
        asset: getTickerCellData(merged),
        base: getBaseCellData(merged),
        thirtyMinBaseVolumeAvgChange: utility.precisionRound(
          getThirtyMinBaseVolumeAvg(merged),
          2,
        ),
        twentyFourHrPriceChange: get24HourPriceChange(merged),
      };
      objects[key] = merged.merge(custom);
      const mutated = {
        thirtyMinBsRatio: utility
          .precisionRound(objects[key]['thirtyMinBsRatio'], 2)
          .toFixed(2),
        thirtyMinPriceChange: utility
          .precisionRound(objects[key]['thirtyMinPriceChange'], 2)
          .toFixed(2),
        twentyFourHrPriceChange: utility
          .precisionRound(objects[key]['twentyFourHrPriceChange'], 2)
          .toFixed(2),
      };
      objects[key] = objects[key].merge(mutated);
    });
    return objects;
  },
);

const filteredResultsSelector = createSelector(mergeDataSelector, snapshots => {
  let dataKeys = columns.map(column => column.dataKey);
  dataKeys.push('ticker');
  dataKeys.push('key');
  const tickers = Object.keys(snapshots);
  let results = {};
  tickers.forEach(ticker => {
    let obj = {};
    const snapshot = snapshots[ticker];
    const props = Object.keys(snapshot).filter(
      key => dataKeys.indexOf(key) > -1,
    );
    props.forEach(prop => {
      obj[prop] = snapshot[prop];
    });
    results[ticker] = obj;
  });
  return results;
});

export default filteredResultsSelector;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsTable/selector.js